(() => {
  const key = 'hn_global_wishlist_v1';
  const legacyKey = 'hn_hng04_wishlist_v1';
  const lifetime = 7 * 24 * 60 * 60 * 1000;

  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      const items = Array.isArray(stored) ? stored.filter((item) => item?.handle && item.expiresAt > Date.now()) : [];
      const legacy = JSON.parse(localStorage.getItem(legacyKey) || 'null');
      if (legacy?.handle && legacy.expiresAt > Date.now() && !items.some((item) => item.handle === legacy.handle)) {
        items.push(legacy);
        localStorage.setItem(key, JSON.stringify(items));
      }
      localStorage.removeItem(legacyKey);
      return items;
    } catch {
      return [];
    }
  };

  const write = (items) => {
    try {
      localStorage.setItem(key, JSON.stringify(items));
      return true;
    } catch {
      return false;
    }
  };

  const setupProduct = () => {
    const handle = document.body.dataset.hnProductHandle;
    const gallery = document.querySelector('.product-information__media media-gallery');
    if (!handle || !gallery || gallery.querySelector('.hn-ui-wishlist-toggle')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'hn-ui-wishlist-toggle';
    button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M16.4186 11.0814L10.7071 16.7929C10.3165 17.1834 9.68338 17.1834 9.29285 16.7929L3.5813 11.0814C1.80884 9.30889 1.80884 6.43516 3.5813 4.66269C5.11274 3.13125 7.46631 2.923 9.22134 4.03795C9.68751 4.3341 10.3124 4.3341 10.7786 4.03795C12.5336 2.923 14.8872 3.13125 16.4186 4.66269C18.1911 6.43516 18.1911 9.30889 16.4186 11.0814Z" fill="#9C9391"/></svg>';

    const sync = () => {
      const saved = read().some((item) => item.handle === handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? 'Remove from favorites' : 'Add to favorites');
      button.title = saved ? 'Remove from favorites' : 'Add to favorites';
    };

    button.addEventListener('click', () => {
      const items = read();
      const existing = items.findIndex((item) => item.handle === handle);
      if (existing >= 0) items.splice(existing, 1);
      else items.push({
        handle,
        title: document.querySelector('.hn-pdp-summary__title')?.textContent.trim() || document.title,
        image: gallery.querySelector('.product-media img')?.src || '',
        url: document.body.dataset.hnProductUrl || `/products/${encodeURIComponent(handle)}`,
        expiresAt: Date.now() + lifetime,
      });
      if (write(items)) sync();
    });

    gallery.append(button);
    sync();
  };

  const setupWishlistPage = () => {
    const root = document.getElementById('hn-ui-wishlist-root');
    if (!root) return;
    const list = document.getElementById('hn-ui-wishlist-items');
    const empty = document.getElementById('hn-ui-wishlist-empty');
    const render = () => {
      const items = read();
      list.replaceChildren();
      list.hidden = !items.length;
      empty.hidden = Boolean(items.length);
      items.forEach((item) => {
        const card = document.createElement('article');
        card.className = 'hn-ui-wishlist__card';
        const link = document.createElement('a');
        link.href = item.url || `/products/${encodeURIComponent(item.handle)}`;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          link.append(image);
        }
        const title = document.createElement('h2');
        title.textContent = item.title || item.handle;
        link.append(title);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', `Remove ${title.textContent} from favorites`);
        remove.addEventListener('click', () => {
          if (write(read().filter((saved) => saved.handle !== item.handle))) render();
        });
        card.append(link, remove);
        list.append(card);
      });
    };
    window.addEventListener('storage', render);
    render();
  };

  const init = () => {
    if (document.body.dataset.hnProductHandle) {
      setupProduct();
      const main = document.getElementById('MainContent');
      if (main) new MutationObserver(setupProduct).observe(main, { childList: true, subtree: true });
      window.addEventListener('storage', () => {
        document.querySelector('.hn-ui-wishlist-toggle')?.remove();
        setupProduct();
      });
    }
    setupWishlistPage();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', setupProduct);
})();
